export default {
  en: [
    { NationalityID: 34, CountryCode: 'AF', Nationality: 'Afghanistan' },
    { NationalityID: 0, CountryCode: 'AX', Nationality: 'Aland Islands' },
    { NationalityID: 35, CountryCode: 'AL', Nationality: 'Albania' },
    { NationalityID: 36, CountryCode: 'DZ', Nationality: 'Algeria' },
    { NationalityID: 37, CountryCode: 'AS', Nationality: 'American Samoa' },
    { NationalityID: 38, CountryCode: 'AD', Nationality: 'Andorra' },
    { NationalityID: 39, CountryCode: 'AO', Nationality: 'Angola' },
    { NationalityID: 0, CountryCode: 'AI', Nationality: 'Anguilla' },
    { NationalityID: 0, CountryCode: 'AQ', Nationality: 'Antarctica' },
    { NationalityID: 0, CountryCode: 'AG', Nationality: 'Antigua and Barbuda' },
    { NationalityID: 2, CountryCode: 'AR', Nationality: 'Argentina' },
    { NationalityID: 40, CountryCode: 'AM', Nationality: 'Armenia' },
    { NationalityID: 0, CountryCode: 'AW', Nationality: 'Aruba' },
    { NationalityID: 3, CountryCode: 'AU', Nationality: 'Australia' },
    { NationalityID: 41, CountryCode: 'AT', Nationality: 'Austria' },
    { NationalityID: 42, CountryCode: 'AZ', Nationality: 'Azerbaijan' },
    { NationalityID: 0, CountryCode: 'BS', Nationality: 'Bahamas' },
    { NationalityID: 43, CountryCode: 'BH', Nationality: 'Bahrain' },
    { NationalityID: 44, CountryCode: 'BD', Nationality: 'Bangladesh' },
    { NationalityID: 45, CountryCode: 'BB', Nationality: 'Barbados' },
    { NationalityID: 46, CountryCode: 'BY', Nationality: 'Belarus' },
    { NationalityID: 0, CountryCode: 'BE', Nationality: 'Belgium' },
    { NationalityID: 47, CountryCode: 'BZ', Nationality: 'Belize' },
    { NationalityID: 48, CountryCode: 'BJ', Nationality: 'Benin' },
    { NationalityID: 49, CountryCode: 'BM', Nationality: 'Bermuda' },
    { NationalityID: 50, CountryCode: 'BT', Nationality: 'Bhutan' },
    { NationalityID: 51, CountryCode: 'BO', Nationality: 'Bolivia (Plurinational State of)' },
    { NationalityID: 0, CountryCode: 'BQ', Nationality: 'Bonaire, Sint Eustatius and Saba' },
    { NationalityID: 52, CountryCode: 'BA', Nationality: 'Bosnia and Herzegovina' },
    { NationalityID: 53, CountryCode: 'BW', Nationality: 'Botswana' },
    { NationalityID: 0, CountryCode: 'BV', Nationality: 'Bouvet Island' },
    { NationalityID: 0, CountryCode: 'BR', Nationality: 'Brazil' },
    { NationalityID: 0, CountryCode: 'IO', Nationality: 'British Indian Ocean Territory' },
    { NationalityID: 0, CountryCode: 'BN', Nationality: 'Brunei Darussalam' },
    { NationalityID: 54, CountryCode: 'BG', Nationality: 'Bulgaria' },
    { NationalityID: 55, CountryCode: 'BF', Nationality: 'Burkina Faso' },
    { NationalityID: 56, CountryCode: 'BI', Nationality: 'Burundi' },
    { NationalityID: 59, CountryCode: 'CV', Nationality: 'Cabo Verde' },
    { NationalityID: 57, CountryCode: 'KH', Nationality: 'Cambodia' },
    { NationalityID: 58, CountryCode: 'CM', Nationality: 'Cameroon' },
    { NationalityID: 7, CountryCode: 'CA', Nationality: 'Canada' },
    { NationalityID: 0, CountryCode: 'KY', Nationality: 'Cayman Islands' },
    { NationalityID: 0, CountryCode: 'CF', Nationality: 'Central African Republic' },
    { NationalityID: 60, CountryCode: 'TD', Nationality: 'Chad' },
    { NationalityID: 61, CountryCode: 'CL', Nationality: 'Chile' },
    { NationalityID: 8, CountryCode: 'CN', Nationality: 'China' },
    { NationalityID: 0, CountryCode: 'CX', Nationality: 'Christmas Island' },
    { NationalityID: 0, CountryCode: 'CC', Nationality: 'Cocos (Keeling) Islands' },
    { NationalityID: 9, CountryCode: 'CO', Nationality: 'Colombia' },
    { NationalityID: 0, CountryCode: 'KM', Nationality: 'Comoros' },
    { NationalityID: 62, CountryCode: 'CG', Nationality: 'Congo' },
    { NationalityID: 0, CountryCode: 'CD', Nationality: 'Congo, Democratic Republic of the' },
    { NationalityID: 0, CountryCode: 'CK', Nationality: 'Cook Islands' },
    { NationalityID: 63, CountryCode: 'CR', Nationality: 'Costa Rica' },
    { NationalityID: 0, CountryCode: 'CI', Nationality: 'Cote d\'Ivoire' },
    { NationalityID: 64, CountryCode: 'HR', Nationality: 'Croatia' },
    { NationalityID: 10, CountryCode: 'CU', Nationality: 'Cuba' },
    { NationalityID: 0, CountryCode: 'CW', Nationality: 'Curacao' },
    { NationalityID: 65, CountryCode: 'CY', Nationality: 'Cyprus' },
    { NationalityID: 66, CountryCode: 'CZ', Nationality: 'Czechia' },
    { NationalityID: 67, CountryCode: 'DK', Nationality: 'Denmark' },
    { NationalityID: 68, CountryCode: 'DJ', Nationality: 'Djibouti' },
    { NationalityID: 69, CountryCode: 'DM', Nationality: 'Dominica' },
    { NationalityID: 11, CountryCode: 'DO', Nationality: 'Dominican Republic' },
    { NationalityID: 12, CountryCode: 'EC', Nationality: 'Ecuador' },
    { NationalityID: 70, CountryCode: 'EG', Nationality: 'Egypt' },
    { NationalityID: 13, CountryCode: 'SV', Nationality: 'El Salvador' },
    { NationalityID: 0, CountryCode: 'GQ', Nationality: 'Equatorial Guinea' },
    { NationalityID: 71, CountryCode: 'ER', Nationality: 'Eritrea' },
    { NationalityID: 72, CountryCode: 'EE', Nationality: 'Estonia' },
    { NationalityID: 146, CountryCode: 'SZ', Nationality: 'Eswatini' },
    { NationalityID: 73, CountryCode: 'ET', Nationality: 'Ethiopia' },
    { NationalityID: 0, CountryCode: 'FK', Nationality: 'Falkland Islands (Malvinas)' },
    { NationalityID: 0, CountryCode: 'FO', Nationality: 'Faroe Islands' },
    { NationalityID: 74, CountryCode: 'FJ', Nationality: 'Fiji' },
    { NationalityID: 75, CountryCode: 'FI', Nationality: 'Finland' },
    { NationalityID: 14, CountryCode: 'FR', Nationality: 'France' },
    { NationalityID: 0, CountryCode: 'GF', Nationality: 'French Guiana' },
    { NationalityID: 76, CountryCode: 'PF', Nationality: 'French Polynesia' },
    { NationalityID: 0, CountryCode: 'TF', Nationality: 'French Southern Territories' },
    { NationalityID: 77, CountryCode: 'GA', Nationality: 'Gabon' },
    { NationalityID: 78, CountryCode: 'GM', Nationality: 'Gambia' },
    { NationalityID: 79, CountryCode: 'GE', Nationality: 'Georgia' },
    { NationalityID: 15, CountryCode: 'DE', Nationality: 'Germany' },
    { NationalityID: 80, CountryCode: 'GH', Nationality: 'Ghana' },
    { NationalityID: 0, CountryCode: 'GI', Nationality: 'Gibraltar' },
    { NationalityID: 81, CountryCode: 'GR', Nationality: 'Greece' },
    { NationalityID: 0, CountryCode: 'GL', Nationality: 'Greenland' },
    { NationalityID: 82, CountryCode: 'GD', Nationality: 'Grenada' },
    { NationalityID: 0, CountryCode: 'GP', Nationality: 'Guadeloupe' },
    { NationalityID: 0, CountryCode: 'GU', Nationality: 'Guam' },
    { NationalityID: 16, CountryCode: 'GT', Nationality: 'Guatemala' },
    { NationalityID: 0, CountryCode: 'GG', Nationality: 'Guernsey' },
    { NationalityID: 83, CountryCode: 'GN', Nationality: 'Guinea' },
    { NationalityID: 0, CountryCode: 'GW', Nationality: 'Guinea-Bissau' },
    { NationalityID: 84, CountryCode: 'GY', Nationality: 'Guyana' },
    { NationalityID: 17, CountryCode: 'HT', Nationality: 'Haiti' },
    { NationalityID: 0, CountryCode: 'HM', Nationality: 'Heard Island and McDonald Islands' },
    { NationalityID: 0, CountryCode: 'VA', Nationality: 'Holy See' },
    { NationalityID: 18, CountryCode: 'HN', Nationality: 'Honduras' },
    { NationalityID: 0, CountryCode: 'HK', Nationality: 'Hong Kong' },
    { NationalityID: 85, CountryCode: 'HU', Nationality: 'Hungary' },
    { NationalityID: 86, CountryCode: 'IS', Nationality: 'Iceland' },
    { NationalityID: 19, CountryCode: 'IN', Nationality: 'India' },
    { NationalityID: 87, CountryCode: 'ID', Nationality: 'Indonesia' },
    { NationalityID: 88, CountryCode: 'IR', Nationality: 'Iran (Islamic Republic of)' },
    { NationalityID: 89, CountryCode: 'IQ', Nationality: 'Iraq' },
    { NationalityID: 20, CountryCode: 'IE', Nationality: 'Ireland' },
    { NationalityID: 0, CountryCode: 'IM', Nationality: 'Isle of Man' },
    { NationalityID: 21, CountryCode: 'IL', Nationality: 'Israel' },
    { NationalityID: 22, CountryCode: 'IT', Nationality: 'Italy' },
    { NationalityID: 90, CountryCode: 'JM', Nationality: 'Jamaica' },
    { NationalityID: 23, CountryCode: 'JP', Nationality: 'Japan' },
    { NationalityID: 0, CountryCode: 'JE', Nationality: 'Jersey' },
    { NationalityID: 91, CountryCode: 'JO', Nationality: 'Jordan' },
    { NationalityID: 92, CountryCode: 'KZ', Nationality: 'Kazakhstan' },
    { NationalityID: 93, CountryCode: 'KE', Nationality: 'Kenya' },
    { NationalityID: 0, CountryCode: 'KI', Nationality: 'Kiribati' },
    { NationalityID: 94, CountryCode: 'KP', Nationality: 'Korea (the Democratic People\'s Republic of)' },
    { NationalityID: 24, CountryCode: 'KR', Nationality: 'Korea (the Republic of)' },
    { NationalityID: 95, CountryCode: 'KW', Nationality: 'Kuwait' },
    { NationalityID: 0, CountryCode: 'KG', Nationality: 'Kyrgyzstan' },
    { NationalityID: 0, CountryCode: 'LA', Nationality: 'Lao People\'s Democratic Republic' },
    { NationalityID: 96, CountryCode: 'LV', Nationality: 'Latvia' },
    { NationalityID: 97, CountryCode: 'LB', Nationality: 'Lebanon' },
    { NationalityID: 0, CountryCode: 'LS', Nationality: 'Lesotho' },
    { NationalityID: 98, CountryCode: 'LR', Nationality: 'Liberia' },
    { NationalityID: 99, CountryCode: 'LY', Nationality: 'Libya' },
    { NationalityID: 0, CountryCode: 'LI', Nationality: 'Liechtenstein' },
    { NationalityID: 100, CountryCode: 'LT', Nationality: 'Lithuania' },
    { NationalityID: 101, CountryCode: 'LU', Nationality: 'Luxembourg' },
    { NationalityID: 0, CountryCode: 'MO', Nationality: 'Macau' },
    { NationalityID: 102, CountryCode: 'MG', Nationality: 'Madagascar' },
    { NationalityID: 103, CountryCode: 'MW', Nationality: 'Malawi' },
    { NationalityID: 104, CountryCode: 'MY', Nationality: 'Malaysia' },
    { NationalityID: 105, CountryCode: 'MV', Nationality: 'Maldives' },
    { NationalityID: 106, CountryCode: 'ML', Nationality: 'Mali' },
    { NationalityID: 107, CountryCode: 'MT', Nationality: 'Malta' },
    { NationalityID: 0, CountryCode: 'MH', Nationality: 'Marshall Islands' },
    { NationalityID: 0, CountryCode: 'MQ', Nationality: 'Martinique' },
    { NationalityID: 108, CountryCode: 'MR', Nationality: 'Mauritania' },
    { NationalityID: 109, CountryCode: 'MU', Nationality: 'Mauritius' },
    { NationalityID: 0, CountryCode: 'YT', Nationality: 'Mayotte' },
    { NationalityID: 25, CountryCode: 'MX', Nationality: 'Mexico' },
    { NationalityID: 0, CountryCode: 'FM', Nationality: 'Micronesia (Federated States of)' },
    { NationalityID: 0, CountryCode: 'MD', Nationality: 'Moldova, Republic of' },
    { NationalityID: 110, CountryCode: 'MC', Nationality: 'Monaco' },
    { NationalityID: 111, CountryCode: 'MN', Nationality: 'Mongolia' },
    { NationalityID: 112, CountryCode: 'ME', Nationality: 'Montenegro' },
    { NationalityID: 0, CountryCode: 'MS', Nationality: 'Montserrat' },
    { NationalityID: 113, CountryCode: 'MA', Nationality: 'Morocco' },
    { NationalityID: 114, CountryCode: 'MZ', Nationality: 'Mozambique' },
    { NationalityID: 0, CountryCode: 'MM', Nationality: 'Myanmar' },
    { NationalityID: 115, CountryCode: 'NA', Nationality: 'Namibia' },
    { NationalityID: 0, CountryCode: 'NR', Nationality: 'Nauru' },
    { NationalityID: 116, CountryCode: 'NP', Nationality: 'Nepal' },
    { NationalityID: 26, CountryCode: 'NL', Nationality: 'Netherlands' },
    { NationalityID: 0, CountryCode: 'NC', Nationality: 'New Caledonia' },
    { NationalityID: 117, CountryCode: 'NZ', Nationality: 'New Zealand' },
    { NationalityID: 118, CountryCode: 'NI', Nationality: 'Nicaragua' },
    { NationalityID: 119, CountryCode: 'NE', Nationality: 'Niger' },
    { NationalityID: 120, CountryCode: 'NG', Nationality: 'Nigeria' },
    { NationalityID: 0, CountryCode: 'NU', Nationality: 'Niue' },
    { NationalityID: 0, CountryCode: 'NF', Nationality: 'Norfolk Island' },
    { NationalityID: 0, CountryCode: 'MK', Nationality: 'North Macedonia' },
    { NationalityID: 0, CountryCode: 'MP', Nationality: 'Northern Mariana Islands' },
    { NationalityID: 121, CountryCode: 'NO', Nationality: 'Norway' },
    { NationalityID: 122, CountryCode: 'OM', Nationality: 'Oman' },
    { NationalityID: 123, CountryCode: 'PK', Nationality: 'Pakistan' },
    { NationalityID: 0, CountryCode: 'PW', Nationality: 'Palau' },
    { NationalityID: 0, CountryCode: 'PS', Nationality: 'Palestine, State of' },
    { NationalityID: 124, CountryCode: 'PA', Nationality: 'Panama' },
    { NationalityID: 125, CountryCode: 'PG', Nationality: 'Papua New Guinea' },
    { NationalityID: 126, CountryCode: 'PY', Nationality: 'Paraguay' },
    { NationalityID: 127, CountryCode: 'PE', Nationality: 'Peru' },
    { NationalityID: 27, CountryCode: 'PH', Nationality: 'Philippines' },
    { NationalityID: 0, CountryCode: 'PN', Nationality: 'Pitcairn' },
    { NationalityID: 128, CountryCode: 'PL', Nationality: 'Poland' },
    { NationalityID: 129, CountryCode: 'PT', Nationality: 'Portugal' },
    { NationalityID: 0, CountryCode: 'PR', Nationality: 'Puerto Rico' },
    { NationalityID: 130, CountryCode: 'QA', Nationality: 'Qatar' },
    { NationalityID: 0, CountryCode: 'RE', Nationality: 'Reunion' },
    { NationalityID: 131, CountryCode: 'RO', Nationality: 'Romania' },
    { NationalityID: 0, CountryCode: 'RU', Nationality: 'Russian Federation' },
    { NationalityID: 132, CountryCode: 'RW', Nationality: 'Rwanda' },
    { NationalityID: 0, CountryCode: 'BL', Nationality: 'Saint Barthelemy' },
    { NationalityID: 0, CountryCode: 'SH', Nationality: 'Saint Helena, Ascension and Tristan da Cunha' },
    { NationalityID: 0, CountryCode: 'KN', Nationality: 'Saint Kitts and Nevis' },
    { NationalityID: 0, CountryCode: 'LC', Nationality: 'Saint Lucia' },
    { NationalityID: 0, CountryCode: 'MF', Nationality: 'Saint Martin (French part)' },
    { NationalityID: 0, CountryCode: 'PM', Nationality: 'Saint Pierre and Miquelon' },
    { NationalityID: 0, CountryCode: 'VC', Nationality: 'Saint Vincent and the Grenadines' },
    { NationalityID: 0, CountryCode: 'WS', Nationality: 'Samoa' },
    { NationalityID: 0, CountryCode: 'SM', Nationality: 'San Marino' },
    { NationalityID: 0, CountryCode: 'ST', Nationality: 'Sao Tome and Principe' },
    { NationalityID: 133, CountryCode: 'SA', Nationality: 'Saudi Arabia' },
    { NationalityID: 134, CountryCode: 'SN', Nationality: 'Senegal' },
    { NationalityID: 135, CountryCode: 'RS', Nationality: 'Serbia' },
    { NationalityID: 0, CountryCode: 'SC', Nationality: 'Seychelles' },
    { NationalityID: 136, CountryCode: 'SL', Nationality: 'Sierra Leone' },
    { NationalityID: 137, CountryCode: 'SG', Nationality: 'Singapore' },
    { NationalityID: 0, CountryCode: 'SX', Nationality: 'Sint Maarten (Dutch part)' },
    { NationalityID: 138, CountryCode: 'SK', Nationality: 'Slovakia' },
    { NationalityID: 139, CountryCode: 'SI', Nationality: 'Slovenia' },
    { NationalityID: 140, CountryCode: 'SB', Nationality: 'Solomon Islands' },
    { NationalityID: 141, CountryCode: 'SO', Nationality: 'Somalia' },
    { NationalityID: 142, CountryCode: 'ZA', Nationality: 'South Africa' },
    { NationalityID: 0, CountryCode: 'GS', Nationality: 'South Georgia and the South Sandwich Islands' },
    { NationalityID: 0, CountryCode: 'SS', Nationality: 'South Sudan' },
    { NationalityID: 28, CountryCode: 'ES', Nationality: 'Spain' },
    { NationalityID: 143, CountryCode: 'LK', Nationality: 'Sri Lanka' },
    { NationalityID: 144, CountryCode: 'SD', Nationality: 'Sudan' },
    { NationalityID: 145, CountryCode: 'SR', Nationality: 'Suriname' },
    { NationalityID: 0, CountryCode: 'SJ', Nationality: 'Svalbard and Jan Mayen' },
    { NationalityID: 29, CountryCode: 'SE', Nationality: 'Swedish' },
    { NationalityID: 30, CountryCode: 'CH', Nationality: 'Switzerland' },
    { NationalityID: 0, CountryCode: 'SY', Nationality: 'Syrian Arab Republic' },
    { NationalityID: 31, CountryCode: 'TW', Nationality: 'Taiwan, Republic of' },
    { NationalityID: 147, CountryCode: 'TJ', Nationality: 'Tajikistan' },
    { NationalityID: 0, CountryCode: 'TZ', Nationality: 'Tanzania, United Republic of' },
    { NationalityID: 148, CountryCode: 'TH', Nationality: 'Thailand' },
    { NationalityID: 0, CountryCode: 'TL', Nationality: 'Timor-Leste' },
    { NationalityID: 149, CountryCode: 'TG', Nationality: 'Togo' },
    { NationalityID: 0, CountryCode: 'TK', Nationality: 'Tokelau' },
    { NationalityID: 0, CountryCode: 'TO', Nationality: 'Tonga' },
    { NationalityID: 150, CountryCode: 'TT', Nationality: 'Trinidad and Tobago' },
    { NationalityID: 151, CountryCode: 'TN', Nationality: 'Tunisia' },
    { NationalityID: 152, CountryCode: 'TR', Nationality: 'Turkey' },
    { NationalityID: 153, CountryCode: 'TM', Nationality: 'Turkmenistan' },
    { NationalityID: 0, CountryCode: 'TC', Nationality: 'Turks and Caicos Islands' },
    { NationalityID: 154, CountryCode: 'TV', Nationality: 'Tuvalu' },
    { NationalityID: 155, CountryCode: 'UG', Nationality: 'Uganda' },
    { NationalityID: 156, CountryCode: 'UA', Nationality: 'Ukraine' },
    { NationalityID: 157, CountryCode: 'AE', Nationality: 'United Arab Emirates' },
    { NationalityID: 1, CountryCode: 'GB', Nationality: 'United Kingdom of Great Britain and Northern Ireland' },
    { NationalityID: 0, CountryCode: 'UM', Nationality: 'United States Minor Outlying Islands' },
    { NationalityID: 158, CountryCode: 'US', Nationality: 'United States of America' },
    { NationalityID: 159, CountryCode: 'UY', Nationality: 'Uruguay' },
    { NationalityID: 160, CountryCode: 'UZ', Nationality: 'Uzbekistan' },
    { NationalityID: 161, CountryCode: 'VU', Nationality: 'Vanuatu' },
    { NationalityID: 32, CountryCode: 'VE', Nationality: 'Venezuela (Bolivarian Republic of)' },
    { NationalityID: 33, CountryCode: 'VN', Nationality: 'Viet Nam' },
    { NationalityID: 0, CountryCode: 'VG', Nationality: 'Virgin Islands (British)' },
    { NationalityID: 0, CountryCode: 'VI', Nationality: 'Virgin Islands (U.S.)' },
    { NationalityID: 0, CountryCode: 'WF', Nationality: 'Wallis and Futuna' },
    { NationalityID: 0, CountryCode: 'EH', Nationality: 'Western Sahara' },
    { NationalityID: 162, CountryCode: 'YE', Nationality: 'Yemen' },
    { NationalityID: 163, CountryCode: 'ZM', Nationality: 'Zambia' },
    { NationalityID: 0, CountryCode: 'ZW', Nationality: 'Zimbabwe' }
  ],
  ja: [
    { NationalityID: 23, CountryCode: 'JP', Nationality: '日本' },
    { NationalityID: 86, CountryCode: 'IS', Nationality: 'アイスランド' },
    { NationalityID: 20, CountryCode: 'IE', Nationality: 'アイルランド' },
    { NationalityID: 42, CountryCode: 'AZ', Nationality: 'アゼルバイジャン' },
    { NationalityID: 34, CountryCode: 'AF', Nationality: 'アフガニスタン' },
    { NationalityID: 158, CountryCode: 'US', Nationality: 'アメリカ合衆国' },
    { NationalityID: 0, CountryCode: 'VI', Nationality: 'アメリカ領ヴァージン諸島' },
    { NationalityID: 37, CountryCode: 'AS', Nationality: 'アメリカ領サモア' },
    { NationalityID: 157, CountryCode: 'AE', Nationality: 'アラブ首長国連邦' },
    { NationalityID: 36, CountryCode: 'DZ', Nationality: 'アルジェリア' },
    { NationalityID: 2, CountryCode: 'AR', Nationality: 'アルゼンチン' },
    { NationalityID: 0, CountryCode: 'AW', Nationality: 'アルバ' },
    { NationalityID: 35, CountryCode: 'AL', Nationality: 'アルバニア' },
    { NationalityID: 40, CountryCode: 'AM', Nationality: 'アルメニア' },
    { NationalityID: 0, CountryCode: 'AI', Nationality: 'アンギラ' },
    { NationalityID: 39, CountryCode: 'AO', Nationality: 'アンゴラ' },
    { NationalityID: 0, CountryCode: 'AG', Nationality: 'アンティグア・バーブーダ' },
    { NationalityID: 38, CountryCode: 'AD', Nationality: 'アンドラ' },
    { NationalityID: 162, CountryCode: 'YE', Nationality: 'イエメン' },
    { NationalityID: 1, CountryCode: 'GB', Nationality: 'イギリス' },
    { NationalityID: 0, CountryCode: 'IO', Nationality: 'イギリス領インド洋地域' },
    { NationalityID: 0, CountryCode: 'VG', Nationality: 'イギリス領ヴァージン諸島' },
    { NationalityID: 21, CountryCode: 'IL', Nationality: 'イスラエル' },
    { NationalityID: 22, CountryCode: 'IT', Nationality: 'イタリア' },
    { NationalityID: 89, CountryCode: 'IQ', Nationality: 'イラク' },
    { NationalityID: 88, CountryCode: 'IR', Nationality: 'イラン・イスラム共和国' },
    { NationalityID: 19, CountryCode: 'IN', Nationality: 'インド' },
    { NationalityID: 87, CountryCode: 'ID', Nationality: 'インドネシア' },
    { NationalityID: 0, CountryCode: 'WF', Nationality: 'ウォリス・フツナ' },
    { NationalityID: 155, CountryCode: 'UG', Nationality: 'ウガンダ' },
    { NationalityID: 156, CountryCode: 'UA', Nationality: 'ウクライナ' },
    { NationalityID: 160, CountryCode: 'UZ', Nationality: 'ウズベキスタン' },
    { NationalityID: 159, CountryCode: 'UY', Nationality: 'ウルグアイ' },
    { NationalityID: 12, CountryCode: 'EC', Nationality: 'エクアドル' },
    { NationalityID: 70, CountryCode: 'EG', Nationality: 'エジプト' },
    { NationalityID: 72, CountryCode: 'EE', Nationality: 'エストニア' },
    { NationalityID: 146, CountryCode: 'SZ', Nationality: 'エスワティニ' },
    { NationalityID: 73, CountryCode: 'ET', Nationality: 'エチオピア' },
    { NationalityID: 71, CountryCode: 'ER', Nationality: 'エリトリア' },
    { NationalityID: 13, CountryCode: 'SV', Nationality: 'エルサルバドル' },
    { NationalityID: 3, CountryCode: 'AU', Nationality: 'オーストラリア' },
    { NationalityID: 41, CountryCode: 'AT', Nationality: 'オーストリア' },
    { NationalityID: 0, CountryCode: 'AX', Nationality: 'オーランド諸島' },
    { NationalityID: 122, CountryCode: 'OM', Nationality: 'オマーン' },
    { NationalityID: 26, CountryCode: 'NL', Nationality: 'オランダ' },
    { NationalityID: 80, CountryCode: 'GH', Nationality: 'ガーナ' },
    { NationalityID: 59, CountryCode: 'CV', Nationality: 'カーボベルデ' },
    { NationalityID: 0, CountryCode: 'GG', Nationality: 'ガーンジー' },
    { NationalityID: 84, CountryCode: 'GY', Nationality: 'ガイアナ' },
    { NationalityID: 92, CountryCode: 'KZ', Nationality: 'カザフスタン' },
    { NationalityID: 130, CountryCode: 'QA', Nationality: 'カタール' },
    { NationalityID: 7, CountryCode: 'CA', Nationality: 'カナダ' },
    { NationalityID: 77, CountryCode: 'GA', Nationality: 'ガボン' },
    { NationalityID: 58, CountryCode: 'CM', Nationality: 'カメルーン' },
    { NationalityID: 78, CountryCode: 'GM', Nationality: 'ガンビア' },
    { NationalityID: 57, CountryCode: 'KH', Nationality: 'カンボジア' },
    { NationalityID: 83, CountryCode: 'GN', Nationality: 'ギニア' },
    { NationalityID: 0, CountryCode: 'GW', Nationality: 'ギニアビサウ' },
    { NationalityID: 65, CountryCode: 'CY', Nationality: 'キプロス' },
    { NationalityID: 10, CountryCode: 'CU', Nationality: 'キューバ' },
    { NationalityID: 0, CountryCode: 'CW', Nationality: 'キュラソー' },
    { NationalityID: 81, CountryCode: 'GR', Nationality: 'ギリシャ' },
    { NationalityID: 0, CountryCode: 'KI', Nationality: 'キリバス' },
    { NationalityID: 0, CountryCode: 'KG', Nationality: 'キルギス' },
    { NationalityID: 16, CountryCode: 'GT', Nationality: 'グアテマラ' },
    { NationalityID: 0, CountryCode: 'GP', Nationality: 'グアドループ' },
    { NationalityID: 0, CountryCode: 'GU', Nationality: 'グアム' },
    { NationalityID: 95, CountryCode: 'KW', Nationality: 'クウェート' },
    { NationalityID: 0, CountryCode: 'CK', Nationality: 'クック諸島' },
    { NationalityID: 0, CountryCode: 'GL', Nationality: 'グリーンランド' },
    { NationalityID: 0, CountryCode: 'CX', Nationality: 'クリスマス島' },
    { NationalityID: 82, CountryCode: 'GD', Nationality: 'グレナダ' },
    { NationalityID: 64, CountryCode: 'HR', Nationality: 'クロアチア' },
    { NationalityID: 0, CountryCode: 'KY', Nationality: 'ケイマン諸島' },
    { NationalityID: 93, CountryCode: 'KE', Nationality: 'ケニア' },
    { NationalityID: 0, CountryCode: 'CI', Nationality: 'コートジボワール' },
    { NationalityID: 0, CountryCode: 'CC', Nationality: 'ココス（キーリング）諸島' },
    { NationalityID: 63, CountryCode: 'CR', Nationality: 'コスタリカ' },
    { NationalityID: 0, CountryCode: 'KM', Nationality: 'コモロ' },
    { NationalityID: 9, CountryCode: 'CO', Nationality: 'コロンビア' },
    { NationalityID: 62, CountryCode: 'CG', Nationality: 'コンゴ共和国' },
    { NationalityID: 0, CountryCode: 'CD', Nationality: 'コンゴ民主共和国' },
    { NationalityID: 133, CountryCode: 'SA', Nationality: 'サウジアラビア' },
    { NationalityID: 0, CountryCode: 'GS', Nationality: 'サウスジョージア・サウスサンドウィッチ諸島' },
    { NationalityID: 0, CountryCode: 'WS', Nationality: 'サモア' },
    { NationalityID: 0, CountryCode: 'BL', Nationality: 'サン・バルテルミー' },
    { NationalityID: 0, CountryCode: 'MF', Nationality: 'サン・マルタン（フランス領）' },
    { NationalityID: 0, CountryCode: 'ST', Nationality: 'サントメ・プリンシペ' },
    { NationalityID: 163, CountryCode: 'ZM', Nationality: 'ザンビア' },
    { NationalityID: 0, CountryCode: 'PM', Nationality: 'サンピエール島・ミクロン島' },
    { NationalityID: 0, CountryCode: 'SM', Nationality: 'サンマリノ' },
    { NationalityID: 136, CountryCode: 'SL', Nationality: 'シエラレオネ' },
    { NationalityID: 68, CountryCode: 'DJ', Nationality: 'ジブチ' },
    { NationalityID: 0, CountryCode: 'GI', Nationality: 'ジブラルタル' },
    { NationalityID: 0, CountryCode: 'JE', Nationality: 'ジャージー' },
    { NationalityID: 90, CountryCode: 'JM', Nationality: 'ジャマイカ' },
    { NationalityID: 79, CountryCode: 'GE', Nationality: 'ジョージア' },
    { NationalityID: 0, CountryCode: 'SY', Nationality: 'シリア・アラブ共和国' },
    { NationalityID: 137, CountryCode: 'SG', Nationality: 'シンガポール' },
    { NationalityID: 0, CountryCode: 'SX', Nationality: 'シント・マールテン（オランダ領）' },
    { NationalityID: 0, CountryCode: 'ZW', Nationality: 'ジンバブエ' },
    { NationalityID: 30, CountryCode: 'CH', Nationality: 'スイス' },
    { NationalityID: 0, CountryCode: 'SJ', Nationality: 'スヴァールバル諸島およびヤンマイエン島' },
    { NationalityID: 29, CountryCode: 'SE', Nationality: 'スウェーデン' },
    { NationalityID: 144, CountryCode: 'SD', Nationality: 'スーダン' },
    { NationalityID: 28, CountryCode: 'ES', Nationality: 'スペイン' },
    { NationalityID: 145, CountryCode: 'SR', Nationality: 'スリナム' },
    { NationalityID: 143, CountryCode: 'LK', Nationality: 'スリランカ' },
    { NationalityID: 138, CountryCode: 'SK', Nationality: 'スロバキア' },
    { NationalityID: 139, CountryCode: 'SI', Nationality: 'スロベニア' },
    { NationalityID: 0, CountryCode: 'SC', Nationality: 'セーシェル' },
    { NationalityID: 134, CountryCode: 'SN', Nationality: 'セネガル' },
    { NationalityID: 135, CountryCode: 'RS', Nationality: 'セルビア' },
    { NationalityID: 0, CountryCode: 'KN', Nationality: 'セントクリストファー・ネイビス' },
    { NationalityID: 0, CountryCode: 'VC', Nationality: 'セントビンセント・グレナディーン' },
    { NationalityID: 0, CountryCode: 'SH', Nationality: 'セントヘレナ・アセンションおよびトリスタンダクーニャ' },
    { NationalityID: 0, CountryCode: 'LC', Nationality: 'セントルシア' },
    { NationalityID: 141, CountryCode: 'SO', Nationality: 'ソマリア' },
    { NationalityID: 140, CountryCode: 'SB', Nationality: 'ソロモン諸島' },
    { NationalityID: 0, CountryCode: 'TC', Nationality: 'タークス・カイコス諸島' },
    { NationalityID: 148, CountryCode: 'TH', Nationality: 'タイ' },
    { NationalityID: 147, CountryCode: 'TJ', Nationality: 'タジキスタン' },
    { NationalityID: 0, CountryCode: 'TZ', Nationality: 'タンザニア' },
    { NationalityID: 66, CountryCode: 'CZ', Nationality: 'チェコ' },
    { NationalityID: 60, CountryCode: 'TD', Nationality: 'チャド' },
    { NationalityID: 151, CountryCode: 'TN', Nationality: 'チュニジア' },
    { NationalityID: 61, CountryCode: 'CL', Nationality: 'チリ' },
    { NationalityID: 154, CountryCode: 'TV', Nationality: 'ツバル' },
    { NationalityID: 67, CountryCode: 'DK', Nationality: 'デンマーク' },
    { NationalityID: 15, CountryCode: 'DE', Nationality: 'ドイツ' },
    { NationalityID: 149, CountryCode: 'TG', Nationality: 'トーゴ' },
    { NationalityID: 0, CountryCode: 'TK', Nationality: 'トケラウ' },
    { NationalityID: 11, CountryCode: 'DO', Nationality: 'ドミニカ共和国' },
    { NationalityID: 69, CountryCode: 'DM', Nationality: 'ドミニカ国' },
    { NationalityID: 150, CountryCode: 'TT', Nationality: 'トリニダード・トバゴ' },
    { NationalityID: 153, CountryCode: 'TM', Nationality: 'トルクメニスタン' },
    { NationalityID: 152, CountryCode: 'TR', Nationality: 'トルコ' },
    { NationalityID: 0, CountryCode: 'TO', Nationality: 'トンガ' },
    { NationalityID: 120, CountryCode: 'NG', Nationality: 'ナイジェリア' },
    { NationalityID: 0, CountryCode: 'NR', Nationality: 'ナウル' },
    { NationalityID: 115, CountryCode: 'NA', Nationality: 'ナミビア' },
    { NationalityID: 0, CountryCode: 'NU', Nationality: 'ニウエ' },
    { NationalityID: 118, CountryCode: 'NI', Nationality: 'ニカラグア' },
    { NationalityID: 119, CountryCode: 'NE', Nationality: 'ニジェール' },
    { NationalityID: 0, CountryCode: 'NC', Nationality: 'ニューカレドニア' },
    { NationalityID: 117, CountryCode: 'NZ', Nationality: 'ニュージーランド' },
    { NationalityID: 116, CountryCode: 'NP', Nationality: 'ネパール' },
    { NationalityID: 0, CountryCode: 'NF', Nationality: 'ノーフォーク島' },
    { NationalityID: 121, CountryCode: 'NO', Nationality: 'ノルウェー' },
    { NationalityID: 0, CountryCode: 'HM', Nationality: 'ハード島とマクドナルド諸島' },
    { NationalityID: 43, CountryCode: 'BH', Nationality: 'バーレーン' },
    { NationalityID: 17, CountryCode: 'HT', Nationality: 'ハイチ' },
    { NationalityID: 123, CountryCode: 'PK', Nationality: 'パキスタン' },
    { NationalityID: 0, CountryCode: 'VA', Nationality: 'バチカン市国' },
    { NationalityID: 124, CountryCode: 'PA', Nationality: 'パナマ' },
    { NationalityID: 161, CountryCode: 'VU', Nationality: 'バヌアツ' },
    { NationalityID: 0, CountryCode: 'BS', Nationality: 'バハマ' },
    { NationalityID: 125, CountryCode: 'PG', Nationality: 'パプアニューギニア' },
    { NationalityID: 49, CountryCode: 'BM', Nationality: 'バミューダ' },
    { NationalityID: 0, CountryCode: 'PW', Nationality: 'パラオ' },
    { NationalityID: 126, CountryCode: 'PY', Nationality: 'パラグアイ' },
    { NationalityID: 45, CountryCode: 'BB', Nationality: 'バルバドス' },
    { NationalityID: 0, CountryCode: 'PS', Nationality: 'パレスチナ' },
    { NationalityID: 85, CountryCode: 'HU', Nationality: 'ハンガリー' },
    { NationalityID: 44, CountryCode: 'BD', Nationality: 'バングラデシュ' },
    { NationalityID: 0, CountryCode: 'PN', Nationality: 'ピトケアン' },
    { NationalityID: 74, CountryCode: 'FJ', Nationality: 'フィジー' },
    { NationalityID: 27, CountryCode: 'PH', Nationality: 'フィリピン' },
    { NationalityID: 75, CountryCode: 'FI', Nationality: 'フィンランド' },
    { NationalityID: 50, CountryCode: 'BT', Nationality: 'ブータン' },
    { NationalityID: 0, CountryCode: 'BV', Nationality: 'ブーベ島' },
    { NationalityID: 0, CountryCode: 'PR', Nationality: 'プエルトリコ' },
    { NationalityID: 0, CountryCode: 'FO', Nationality: 'フェロー諸島' },
    { NationalityID: 0, CountryCode: 'FK', Nationality: 'フォークランド（マルビナス）諸島' },
    { NationalityID: 0, CountryCode: 'BR', Nationality: 'ブラジル' },
    { NationalityID: 14, CountryCode: 'FR', Nationality: 'フランス' },
    { NationalityID: 0, CountryCode: 'GF', Nationality: 'フランス領ギアナ' },
    { NationalityID: 76, CountryCode: 'PF', Nationality: 'フランス領ポリネシア' },
    { NationalityID: 0, CountryCode: 'TF', Nationality: 'フランス領南方・南極地域' },
    { NationalityID: 54, CountryCode: 'BG', Nationality: 'ブルガリア' },
    { NationalityID: 55, CountryCode: 'BF', Nationality: 'ブルキナファソ' },
    { NationalityID: 0, CountryCode: 'BN', Nationality: 'ブルネイ・ダルサラーム' },
    { NationalityID: 56, CountryCode: 'BI', Nationality: 'ブルンジ' },
    { NationalityID: 33, CountryCode: 'VN', Nationality: 'ベトナム' },
    { NationalityID: 48, CountryCode: 'BJ', Nationality: 'ベナン' },
    { NationalityID: 32, CountryCode: 'VE', Nationality: 'ベネズエラ・ボリバル共和国' },
    { NationalityID: 46, CountryCode: 'BY', Nationality: 'ベラルーシ' },
    { NationalityID: 47, CountryCode: 'BZ', Nationality: 'ベリーズ' },
    { NationalityID: 127, CountryCode: 'PE', Nationality: 'ペルー' },
    { NationalityID: 0, CountryCode: 'BE', Nationality: 'ベルギー' },
    { NationalityID: 128, CountryCode: 'PL', Nationality: 'ポーランド' },
    { NationalityID: 52, CountryCode: 'BA', Nationality: 'ボスニア・ヘルツェゴビナ' },
    { NationalityID: 53, CountryCode: 'BW', Nationality: 'ボツワナ' },
    { NationalityID: 0, CountryCode: 'BQ', Nationality: 'ボネール、シント・ユースタティウスおよびサバ' },
    { NationalityID: 51, CountryCode: 'BO', Nationality: 'ボリビア多民族国' },
    { NationalityID: 129, CountryCode: 'PT', Nationality: 'ポルトガル' },
    { NationalityID: 18, CountryCode: 'HN', Nationality: 'ホンジュラス' },
    { NationalityID: 0, CountryCode: 'MH', Nationality: 'マーシャル諸島' },
    { NationalityID: 0, CountryCode: 'MO', Nationality: 'マカオ' },
    { NationalityID: 102, CountryCode: 'MG', Nationality: 'マダガスカル' },
    { NationalityID: 0, CountryCode: 'YT', Nationality: 'マヨット' },
    { NationalityID: 103, CountryCode: 'MW', Nationality: 'マラウイ' },
    { NationalityID: 106, CountryCode: 'ML', Nationality: 'マリ' },
    { NationalityID: 107, CountryCode: 'MT', Nationality: 'マルタ' },
    { NationalityID: 0, CountryCode: 'MQ', Nationality: 'マルティニーク' },
    { NationalityID: 104, CountryCode: 'MY', Nationality: 'マレーシア' },
    { NationalityID: 0, CountryCode: 'IM', Nationality: 'マン島' },
    { NationalityID: 0, CountryCode: 'FM', Nationality: 'ミクロネシア連邦' },
    { NationalityID: 0, CountryCode: 'MM', Nationality: 'ミャンマー' },
    { NationalityID: 25, CountryCode: 'MX', Nationality: 'メキシコ' },
    { NationalityID: 109, CountryCode: 'MU', Nationality: 'モーリシャス' },
    { NationalityID: 108, CountryCode: 'MR', Nationality: 'モーリタニア' },
    { NationalityID: 114, CountryCode: 'MZ', Nationality: 'モザンビーク' },
    { NationalityID: 110, CountryCode: 'MC', Nationality: 'モナコ' },
    { NationalityID: 105, CountryCode: 'MV', Nationality: 'モルディブ' },
    { NationalityID: 0, CountryCode: 'MD', Nationality: 'モルドバ共和国' },
    { NationalityID: 113, CountryCode: 'MA', Nationality: 'モロッコ' },
    { NationalityID: 111, CountryCode: 'MN', Nationality: 'モンゴル' },
    { NationalityID: 112, CountryCode: 'ME', Nationality: 'モンテネグロ' },
    { NationalityID: 0, CountryCode: 'MS', Nationality: 'モントセラト' },
    { NationalityID: 91, CountryCode: 'JO', Nationality: 'ヨルダン' },
    { NationalityID: 0, CountryCode: 'LA', Nationality: 'ラオス人民民主共和国' },
    { NationalityID: 96, CountryCode: 'LV', Nationality: 'ラトビア' },
    { NationalityID: 100, CountryCode: 'LT', Nationality: 'リトアニア' },
    { NationalityID: 99, CountryCode: 'LY', Nationality: 'リビア' },
    { NationalityID: 0, CountryCode: 'LI', Nationality: 'リヒテンシュタイン' },
    { NationalityID: 98, CountryCode: 'LR', Nationality: 'リベリア' },
    { NationalityID: 131, CountryCode: 'RO', Nationality: 'ルーマニア' },
    { NationalityID: 101, CountryCode: 'LU', Nationality: 'ルクセンブルク' },
    { NationalityID: 132, CountryCode: 'RW', Nationality: 'ルワンダ' },
    { NationalityID: 0, CountryCode: 'LS', Nationality: 'レソト' },
    { NationalityID: 97, CountryCode: 'LB', Nationality: 'レバノン' },
    { NationalityID: 0, CountryCode: 'RE', Nationality: 'レユニオン' },
    { NationalityID: 0, CountryCode: 'RU', Nationality: 'ロシア連邦' },
    { NationalityID: 0, CountryCode: 'HK', Nationality: '香港' },
    { NationalityID: 0, CountryCode: 'UM', Nationality: '合衆国領有小離島' },
    { NationalityID: 0, CountryCode: 'EH', Nationality: '西サハラ' },
    { NationalityID: 0, CountryCode: 'GQ', Nationality: '赤道ギニア' },
    { NationalityID: 31, CountryCode: 'TW', Nationality: '台湾（中華民国）' },
    { NationalityID: 24, CountryCode: 'KR', Nationality: '大韓民国' },
    { NationalityID: 0, CountryCode: 'CF', Nationality: '中央アフリカ共和国' },
    { NationalityID: 8, CountryCode: 'CN', Nationality: '中華人民共和国' },
    { NationalityID: 94, CountryCode: 'KP', Nationality: '朝鮮民主主義人民共和国' },
    { NationalityID: 0, CountryCode: 'TL', Nationality: '東ティモール' },
    { NationalityID: 142, CountryCode: 'ZA', Nationality: '南アフリカ' },
    { NationalityID: 0, CountryCode: 'SS', Nationality: '南スーダン' },
    { NationalityID: 0, CountryCode: 'AQ', Nationality: '南極' },
    { NationalityID: 0, CountryCode: 'MK', Nationality: '北マケドニア' },
    { NationalityID: 0, CountryCode: 'MP', Nationality: '北マリアナ諸島' }
  ]
}
